const actions = {
  SET_STATE: 'toonphotobooth/SET_STATE',
  UPLOAD_IMAGE: 'toonphotobooth/UPLOAD_IMAGE'
}

export default actions
